import axiosInstance from "@/axiosConfig";
import type {
  CampaignAnswer, CampaignOpening, CampaignResponse, CampaignSnapshot, CurrentOffers,
} from "@/shared/types/featureTeasing.types";
const base = (organizationId: string) => `/organizations/${organizationId}/feature_teasing_campaigns`;
export const FeatureTeasingService = {
  async list(organizationId: string, signal: AbortSignal) {
    return (await axiosInstance.get<CurrentOffers>(base(organizationId), { signal })).data;
  },
  async manualOpen(organizationId: string, campaignId: string, openingId: string) {
    return (await axiosInstance.post<CampaignOpening>(`${base(organizationId)}/${campaignId}/manual_open`, { opening_id: openingId })).data;
  },
  async next(organizationId: string, signal: AbortSignal) {
    return (await axiosInstance.get<{ campaign: CampaignSnapshot | null, server_time: string }>(`${base(organizationId)}/next`, { signal })).data;
  },
  async open(organizationId: string, campaignId: string, openingId: string) {
    return (await axiosInstance.post<CampaignOpening>(`${base(organizationId)}/${campaignId}/open`, { opening_id: openingId })).data;
  },
  async shown(organizationId: string, campaignId: string, openingId: string) {
    await axiosInstance.post(`${base(organizationId)}/${campaignId}/shown`, { opening_id: openingId });
  },
  async respond(organizationId: string, campaignId: string, openingId: string, response: CampaignAnswer) {
    return (await axiosInstance.post<CampaignResponse>(`${base(organizationId)}/${campaignId}/responses`, { opening_id: openingId, response })).data;
  },
  async refresh(organizationId: string, campaignId: string, openingId: string) {
    return (await axiosInstance.get<CampaignOpening>(`${base(organizationId)}/${campaignId}/media`, { params: { opening_id: openingId } })).data;
  },
};
